export default __webpack_public_path__ + "2b005cb7850e8f5cae26771f257ed06b.png";